import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {ErrorInfo} from '../../store/ErrorInfo';

@Injectable({providedIn: 'root'})
export class ErrorResolver implements Resolve<ErrorInfo> {

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ErrorInfo> {
    const code = route.queryParamMap.get('code');
    const message = route.queryParamMap.get('error');

    return of({code, message} as ErrorInfo);
  }
}
